import { apiClient } from '@/shared/api/client'

export async function lookupPincode(pincode) {
  const cleanPin = String(pincode || '').trim()
  if (!/^\d{6}$/.test(cleanPin)) {
    return null
  }

  const response = await apiClient.get(`/pincode/${cleanPin}`)
  return response.data?.data || response.data
}

export default { lookupPincode }
